import styled from "styled-components";

import { MapLibreMapHost } from "@ryde/controls";
import { IStyledAttributes } from "@ryde/shared";

export const PolygonEditorStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "polygon-editor",
})`
  /* Fill the LayoutRight content area (column flex, align-items: center,
     height: 0 + min-height) like the old full-panel Google map did. */
  align-self: stretch;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 400px;

  & .toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 20px 24px;
  }

  & .mapArea {
    flex: 1 1 auto;
    min-height: 0;
    position: relative;
  }
`;

/**
 * The editor map itself. Fills `.mapArea`, which is the flex row that grows to whatever the drawer has
 * left after the toolbar.
 */
export const PolygonEditorMapStyled = styled(
  MapLibreMapHost,
).attrs<IStyledAttributes>({
  "data-e2e": "polygon-editor-map",
})`
  height: 100%;
  width: 100%;
`;
